import { FC, PropsWithChildren } from 'react'

import MaintenanceImage from '@editor/assets/imgs/maintenance-page.png'
import { PageError } from '@editor/interfaces/system'
import { AppError } from '@editor/pages/_error/AppError'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

const PageErrorHandler: FC<PropsWithChildren> = ({ children }) => {
  // Store
  const pageError = useSelector((state: RootState) => state.page.pageError)

  switch (pageError) {
    case PageError.NotFound:
      return <AppError description="ページが存在しません" image={MaintenanceImage} />
    case PageError.InternalServerError:
      return (
        <AppError description="エラーが発生しました。時間をおいて、再度実行してください。" image={MaintenanceImage} />
      )
    case PageError.Forbidden:
      return <AppError description="アクセス権限がありません" image={MaintenanceImage} />
    default:
      break
  }

  return <div>{children}</div>
}

export default PageErrorHandler
